import {toast} from 'react-toastify'
import Swal from 'sweetalert2'
import {Message} from '../../../_metronic/helpers'
import {addBand, deleteBands, getBands, getBandsById, updateBandById} from '../../../api/BandAPI'
import {DELETE_MESSAGE, UPDATE_MESSAGE} from '../../../utils/contants'
import {AlertProps} from '../../data/AlertDefaults'

export const getBand = (setBand: Function, setAPIStatus: Function) => {
  setAPIStatus((prev: any) => ({...prev, loading: true}))
  getBands().then((res: any) => {
    if (res.statusCode === 200) {
      const bandsWithIndex = res.data.map((band: any, index: number) => ({
        ...band,
        index: index + 1,
      }))
      setBand(bandsWithIndex)
      setBand(res.data)

      setAPIStatus((prev: any) => ({...prev, loading: false}))
    } else {
      setAPIStatus((prev: any) => ({...prev, loading: false, error: res.message}))
    }
  })
}

// form save function

export const handleSubmit = (
  InputField: {
    bandName: string
    bandDescription: string
    minCtc: string
    maxCtc: string
  },
  getBand: Function,
  setBand: Function,
  setEditId: Function,
  initialState: {
    bandName: string
    bandDescription: string
    minCtc: string
    maxCtc: string
  },
  setInputField: Function,
  editId: string | null,
  cancelSubmit: Function,
  setAPIStatus: Function,
  setInputError: Function,
  valibandLevelForm: Function,
  setSubmitAPIStatus: Function,
  setIsAddUserModalOpen: Function
) => {
  let {cnt, error} = valibandLevelForm(InputField)
  setInputError(error)

  if (cnt === 0) {
    if (editId == null) {
      setSubmitAPIStatus((prev: any) => ({...prev, loading: true}))
      addBand(InputField).then((res) => {
        if (res.statusCode === 200) {
          toast.success(res.message)
          getBand(setBand, setAPIStatus)
          cancelSubmit(setInputField, initialState, setEditId, setInputError)
          setIsAddUserModalOpen(false)
        } else {
          Message(res.message, 'error')
        }
        setSubmitAPIStatus((prev: any) => ({...prev, loading: false}))
      })
    } else {
      Swal.fire({...AlertProps, icon: 'warning', title: UPDATE_MESSAGE}).then((result: any) => {
        if (result.isConfirmed) {
          setSubmitAPIStatus((prev: any) => ({...prev, loading: true}))
          updateBandById(InputField, editId).then((res: any) => {
            if (res.statusCode === 200) {
              getBand(setBand, setAPIStatus)
              toast.success(res.message)
              cancelSubmit(setInputField, initialState, setEditId, setInputError)
              setEditId(null)
              setIsAddUserModalOpen(false)
            } else {
              Message(res.message, 'error')
            }
            setSubmitAPIStatus((prev: any) => ({...prev, loading: false}))
          })
        }
      })
    }
  }
}

// delete band

export const deleteBand = (
  id: string,
  getBand: Function,
  setBand: Function,
  setAPIStatus: Function,
  cancelSubmit: Function,
  setInputField: Function,
  InputField: {
    bandName: string
    bandDescription: string
    minCtc: string
    maxCtc: string
  },
  setEditId: Function,

  setInputError: Function
) => {
  cancelSubmit(setInputField, InputField, setEditId, setInputError)
  Swal.fire({...AlertProps, icon: 'warning', title: DELETE_MESSAGE}).then((result: any) => {
    if (result.isConfirmed) {
      deleteBands(id)
        .then((res: any) => {
          if (res.statusCode === 200) {
            getBand(setBand, setAPIStatus)
            toast.success(res.message)
          } else {
            Message(res.message, 'error')
          }
        })
        .catch((res: any) => {
          Message(res.message, 'error')
        })
    }
  })
}

export const handleInputChange = (
  event: React.SyntheticEvent,
  setInputField: Function,
  InputField: {
    bandName: string
    bandDescription: string
    minCtc: string
    maxCtc: string
  }
) => {
  let target = event.target as HTMLInputElement
  setInputField({
    ...InputField,
    [target.name]: target.type === 'checkbox' ? target.checked : target.value,
  })
}

//getBandByID

export const getBandById = (
  id: string,
  InputField: {
    bandName: string
    bandDescription: string
    minCtc: string
    maxCtc: string
  },
  setInputField: Function,
  setEditId: Function,
  setInputError: Function
) => {
  getBandsById(id).then((res: any) => {
    if (res) {
      setInputField({
        ...InputField,
        bandName: res.data.bandName,
        bandDescription: res.data.bandDescription,
        minCtc: res.data.minCtc,
        maxCtc: res.data.maxCtc,
      })
      setEditId(id)
      setInputError({})
      window.scrollTo(0, 0)
    } else {
      Message(res.message, 'error') // Assuming the Message function is imported from the correct location
    }
  })
}
export const valibandLevelForm = (InputField: {
  bandName: string
  bandDescription: string
  minCtc: string
  maxCtc: string
}) => {
  let cnt = 0
  const error: any = {}

  const minBandLength = 2
  const maxBandLength = 10
  const maxBandDesLength = 250

  const trimmedBandName = InputField.bandName.trim()
  const trimmedBandDescription = InputField.bandDescription.trim()
  const trimmedMaxAnnPac = InputField.maxCtc.trim()
  const trimmedMinAnnPac = InputField.minCtc.trim()

  if (!trimmedBandName) {
    cnt = cnt + 1
    error.bandName = 'Please enter a Band Name.'
  } else if (!/^[A-Za-z0-9\s-]+$/.test(trimmedBandName)) {
    cnt = cnt + 1
    error.bandName = 'Please enter a valid Band Name using only alphanumeric characters.'
  } else if (trimmedBandName.length < minBandLength) {
    cnt = cnt + 1
    error.bandName = 'Band Name must be at least 2 characters.'
  } else if (trimmedBandName.length > maxBandLength) {
    cnt = cnt + 1
    error.bandName = 'Band Name must not exceed 10 characters.'
  }

  if (!trimmedBandDescription) {
    cnt = cnt + 1
    error.bandDescription = 'Please enter a Band Description.'
  } else if (trimmedBandDescription.length < minBandLength) {
    cnt = cnt + 1
    error.bandDescription = 'Band Description must be at least 2 characters.'
  } else if (trimmedBandDescription.length > maxBandDesLength) {
    cnt = cnt + 1
    error.bandDescription = 'Band Description must not exceed 250 characters.'
  }

  if (!trimmedMaxAnnPac) {
    cnt = cnt + 1
    error.maxCtc = 'Please enter a Max Annual Package.'
  } else if (trimmedMaxAnnPac.length < minBandLength) {
    cnt = cnt + 1
    error.maxCtc = 'Max Annual Package must be at least 2 characters.'
  } else if (trimmedMaxAnnPac.length > maxBandLength) {
    cnt = cnt + 1
    error.maxCtc = 'Max Annual Package must not exceed 10 characters.'
  }

  if (!trimmedMinAnnPac) {
    cnt = cnt + 1
    error.minCtc = 'Please enter a Min Annual Package.'
  } else if (trimmedMinAnnPac.length < minBandLength) {
    cnt = cnt + 1
    error.minCtc = 'Min Annual Package must be at least 2 characters.'
  } else if (trimmedMinAnnPac.length > maxBandLength) {
    cnt = cnt + 1
    error.minCtc = 'Min Annual Package must not exceed 10 characters.'
  }
  return {error, cnt}
}
export const cancelSubmit = (
  setInputField: Function,
  InputField: {bandName: string; bandDescription: string; minCtc: string; maxCtc: string},
  setEditId: Function,
  setInputError: Function
) => {
  setEditId(null)
  setInputField(InputField)
  setInputError({})
}
